import React, { useEffect, useState } from 'react';
import InternalBanner from './InternalBanner';
import SkelotonEffect from './SkelotonEffect';
import axios from 'axios';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function Gallery() {
    const apiKey = process.env.REACT_APP_API_KEY;
    const baseURL = process.env.REACT_APP_BASE_URL;
    const [events, setEvents] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [modalImage, setModalImage] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        AOS.init();
    }, []);

    const openModalg = (index) => {
        setModalImage(events[index].image_url);
        setModalTitle(events[index].title);
        setCurrentIndex(index);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const showPreviousImage = () => {
        const newIndex = (currentIndex - 1 + events.length) % events.length;
        setModalImage(events[newIndex].image_url);
        setModalTitle(events[newIndex].title);
        setCurrentIndex(newIndex);
    };

    const showNextImage = () => {
        const newIndex = (currentIndex + 1) % events.length;
        setModalImage(events[newIndex].image_url);
        setModalTitle(events[newIndex].title);
        setCurrentIndex(newIndex);
    };

    useEffect(() => {

        const fetchData = async () => {
            try {
                const response = await axios.get(`${baseURL}/galleryImages`, {
                    headers: {
                        'Authorization': apiKey,
                        accept: 'application/json',
                    }
                });
                setEvents(response.data.data);
                setIsLoading(false);
            } catch (error) {
                setError(error.message);
                setIsLoading(false);
            }
        };

        fetchData();
    }, [baseURL, apiKey]);

   

    return (
        <>
            <InternalBanner title="Gallery" />


            {error ? (
                <section className="error-part">
                    <div className="container">
                        <h1 className='mb-4 d-none'>{error.message}</h1>
                        <img className="img-fluid mb-3" src="assets/images/error.png" alt="error" />

                    </div>
                </section>

            ) : isLoading ? (
                <SkelotonEffect />
            ) : (
                <section className='gallery'>
                    <div className="container">
                        <div className='row'>
                            <div className='col-xl-12 my-4'>
                                <div className='gallery-box'>
                                    <div className="row row-cols-1 row-cols-md-3 row-cols-lg-4 row-cols-xl-4">
                                        {events.map((event, index) => (
                                            <div key={event.id} className="thumb tab">
                                                <div onClick={() => openModalg(index)}>
                                                    <div className="thumbnail effect effect-one">
                                                        <img
                                                            className="w-100"
                                                            src={event.image_url}
                                                            alt={event.title}
                                                        />
                                                        <div className="tab-text">
                                                            <h2>{event.date}</h2>
                                                            <p>{event.event_name}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Conditionally render the modal based on isModalOpen */}
                    {isModalOpen && (
                        <div className="modal d-block" role="dialog">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content" data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                                    <button
                                        className="modal-close icofont-close"
                                        onClick={closeModal} // Close modal on button click
                                    ></button>

                                    <div className="product-view">
                                        <img
                                            className="img-responsive w-100"
                                            src={modalImage}
                                            alt={modalTitle}
                                        />
                                    </div>

                                    <button className="carousel-control-prev" type="button" onClick={showPreviousImage}>
                                        <span className="btn-6 view-all-btnn view-all-btnn-cr" aria-hidden="true">
                                            <img
                                                src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e"
                                                alt="Arrow Icon"
                                            />
                                        </span>
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button className="carousel-control-next" type="button" onClick={showNextImage}>
                                        <span className="btn-6 view-all-btnn view-all-btnn-cr" aria-hidden="true">
                                            <img
                                                src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e"
                                                alt="Arrow Icon"
                                            />
                                        </span>
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </section>

            )}
        </>
    );
}
